/**
 * @generated SignedSource<<383e334e19af1cbda53c47ee984079bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateCardRelayFragment$data = {
  readonly contributor: {
    readonly __typename: "ContentPlatformAuthor";
    readonly organization: {
      readonly name: string | null | undefined;
    } | null | undefined;
  } | {
    readonly __typename: "ContentPlatformOrganization";
    readonly name: string | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly name: string | null | undefined;
  readonly pluginModuleKey: string;
  readonly previewBlurb: string | null | undefined;
  readonly templateId: string;
  readonly templateType: ReadonlyArray<{
    readonly id: string;
    readonly templateTypeName: string | null | undefined;
  }> | null | undefined;
  readonly urlSlug: string | null | undefined;
  readonly " $fragmentType": "templateCardRelayFragment";
};
export type templateCardRelayFragment$key = {
  readonly " $data"?: templateCardRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateCardRelayFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateCardRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateId",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlSlug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pluginModuleKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "previewBlurb",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTaxonomyTemplateType",
      "kind": "LinkedField",
      "name": "templateType",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateTypeName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "contributor",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "ContentPlatformOrganization",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentPlatformOrganization",
              "kind": "LinkedField",
              "name": "organization",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "type": "ContentPlatformAuthor",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplate",
  "abstractKey": null
};
})();

(node as any).hash = "b922f17711de943d1137b478186afffb";

export default node;
